import axios from 'axios'
import {CustomerTicket, CustomerTicketDetailResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL

// Get customer's tickets
export function getMyTickets(): Promise<{data: {tickets: CustomerTicket[]}}> {
  return axios.get(`${API_URL}/api/tickets`)
}

// Get single ticket with messages
export function getTicketDetail(ticketId: string): Promise<{data: CustomerTicketDetailResponse}> {
  return axios.get(`${API_URL}/api/tickets/${ticketId}`)
}

// Get messages only (lightweight, for polling)
export function getTicketMessages(ticketId: string): Promise<{data: {messages: any[]}}> {
  return axios.get(`${API_URL}/api/tickets/${ticketId}/messages`)
}

// Create new ticket
export function createTicket(data: {
  subject: string
  message: string
  attachments?: File[]
}): Promise<{data: {success: boolean; ticket: CustomerTicket}}> {
  const formData = new FormData()
  formData.append('subject', data.subject)
  formData.append('message', data.message)

  if (data.attachments) {
    data.attachments.forEach(file => {
      formData.append('attachments', file)
    })
  }

  return axios.post(`${API_URL}/api/tickets`, formData, {
    headers: {'Content-Type': 'multipart/form-data'}
  })
}

// Add reply to ticket
export function addReply(
  ticketId: string,
  message: string,
  attachments?: File[]
): Promise<{data: {success: boolean}}> {
  const formData = new FormData()
  formData.append('message', message)

  if (attachments) {
    attachments.forEach(file => {
      formData.append('attachments', file)
    })
  }

  return axios.post(`${API_URL}/api/tickets/${ticketId}/messages`, formData, {
    headers: {'Content-Type': 'multipart/form-data'}
  })
}

// Close ticket
export function closeTicket(ticketId: string): Promise<{data: {success: boolean}}> {
  return axios.post(`${API_URL}/api/tickets/${ticketId}/close`)
}

// Get unread count for badge
export function getUnreadCount(): Promise<{data: {count: number}}> {
  return axios.get(`${API_URL}/api/tickets/unread-count`)
}
